import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { SiteMassageModel } from '../models/site-massage.model';


@Injectable({
  providedIn: 'root'
})
export class SiteMassageService {
  constructor(private http: HttpClient) { }
  baseUrl = environment.apiKey;
  token = localStorage.getItem("token");
  httpOptions = {
    headers: new HttpHeaders({
      "Authorization": "Bearer " + this.token,
      "Content-Type": "application/json"
    })
  };

  getAll(): Observable<any> {
    return this.http
      .get<any>(`${this.baseUrl}SiteMessages/GetAll`, this.httpOptions)
      .pipe(
        catchError(error => throwError(() => error))
      );
  }
  getById(id: number): Observable<any> {
    return this.http
      .get<any>(`${this.baseUrl}SiteMessages/GetById/${id}`, this.httpOptions)
      .pipe(
        catchError(error => throwError(() => error))
      );
  }
  insert(payload: SiteMassageModel): Observable<any> {
    return this.http
      .post<any>(`${this.baseUrl}SiteMessages/Insert`, payload, this.httpOptions)
      .pipe(
        catchError(error => throwError(() => error))
      );
  }
}
